import React from 'react'
import './Search_total_project.css'
import Form from 'react-bootstrap/Form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

const Search_total_project = () => {
    return (
        <>
            <div className='Search_total_project_sec theme_bg'>
                <div className='searchdiv'>
                    <Form.Control type="search" placeholder="Search Project" />
                    <FontAwesomeIcon className='serchicn' icon={faMagnifyingGlass} />
                </div>
                <div className='row bdbottt'>
                    <div className='col-8'><p className='totalp'>Total Project:</p></div>
                    <div className='col-4 text-end'><p className='totalp'>9999</p></div>
                </div>
                <div className='row bdbottt'>
                    <div className='col-8'><p className='totalp'>Ongoing Project:</p></div>
                    <div className='col-4 text-end'><p className='totalp'>9999</p></div>
                </div>
                <div className='row bdbottt'>
                    <div className='col-8'><p className='totalp'>Rental Installations:</p></div>
                    <div className='col-4 text-end'><p className='totalp'>9999</p></div>
                </div>
                <div className='row bdbottt'>
                    <div className='col-8'><p className='totalp'>Under AMC:</p></div>
                    <div className='col-4 text-end'><p className='totalp'>9999</p></div>
                </div>
                <div className='row bdbottt'>
                    <div className='col-8'><p className='totalp'>Project Under Warranty:</p></div>
                    <div className='col-4 text-end'><p className='totalp'>9999</p></div>
                </div>
                {/* <div className='row'>
                    <div className='col-8'><p className='totalp2'>Ongoing Project</p></div>
                    <div className='col-4 text-end'><p className='totalp'>99</p></div>
                </div> */}
            </div>
        </>
    )
}

export default Search_total_project